import React, {PureComponent} from 'react';
import {buildSerpUrl} from '../../utils/urls';
import {HeroGrid, GridPanel} from '@homeaway/landing-presentational';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';

function renderPanel({search, host, basePath, pushHandlerClickData}) {
    return (data, index) => {
        const {arrivalDate, departureDate} = search;

        const {fullName, getImageUrl, lbsId, title} = data;

        const urlPath = buildSerpUrl({
            basePath,
            host,
            params: {
                q: fullName,
                arrival: arrivalDate,
                departure: departureDate,
            },
        });

        const imageSrc = index === 0 ? getImageUrl('hw2') : getImageUrl('hw6');

        return (
            <a
                key={index}
                href={urlPath}
                onClick={pushHandlerClickData(lbsId, index + 1)}
            >
                <GridPanel label={title} imageSrc={imageSrc} />
            </a>
        );
    };
}

export class PopularDestinationsComponent extends PureComponent {
    componentDidMount() {
        const {
            basePathPrefix,
            lbsIds = [],
            popularDestinations = [],
            fetchImages,
        } = this.props;

        if (!popularDestinations.length && lbsIds.length) {
            fetchImages({basePathPrefix, lbsIds});
        }
    }

    render() {
        const {
            cityCarouselTitle,
            popularDestinations = [],
            search,
            basePath,
            host,
            ACTION_LOCATION,
            pushHandlerClickData,
            cardTitlesDisplayed,
            cardTitlesLoaded,
        } = this.props;

        if (!popularDestinations.length) {
            return null;
        }

        const sectionClasses = 'container module';

        return (
            <div className={sectionClasses}>
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'top',
                        card_titles_displayed: cardTitlesDisplayed,
                        card_titles_loaded: cardTitlesLoaded,
                    }}
                    edapEvent={'content_module.presented'}
                />
                <h3 className={'page-subheading'}>{cityCarouselTitle}</h3>
                <HeroGrid
                    items={popularDestinations}
                    renderPanel={renderPanel({
                        search,
                        host,
                        basePath,
                        pushHandlerClickData,
                    })}
                />
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'bottom',
                        card_titles_displayed: cardTitlesDisplayed,
                        card_titles_loaded: cardTitlesLoaded,
                    }}
                    edapEvent={'content_module.presented'}
                />
                <EdapViewTracker
                    eventData={{actionlocation: ACTION_LOCATION}}
                />
            </div>
        );
    }
}

export default PopularDestinationsComponent;
